import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const TopMargin = styled.div`
  margin-top: 80px;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    margin-top: 20px;
  }
`;

export const Label = styled.div``;

export const Cards = styled.div`
  display: flex;
  gap: 30px;
  margin-top: 20px;

  > div {
    flex-basis: 100%;
  }

  ${mediaQuery(BREAKPOINTS.tablet)} {
    flex-direction: column;
  }
`;
